import type { BottomTabNavigationEventMap } from '@react-navigation/bottom-tabs'
import type { NavigationHelpers, ParamListBase } from '@react-navigation/native'

import type { ICON } from '@/src/general/enums/icons'

type TTabRouteName = 'prayer-space' | 'communities' | 'intentions' | 'messages'

type TRoute = {
  name: TTabRouteName
  key: string
  params?: Readonly<object | undefined>
}

export type TTabBarDisplayProps = {
  icon: ICON
  text: string
  hasNotifications: boolean
  notificationsCount?: number
  onNavigate: (
    navigation: NavigationHelpers<ParamListBase, BottomTabNavigationEventMap> | undefined,
    route: TRoute,
  ) => void
}

export type TTabNavigationData = Record<TTabRouteName, TTabBarDisplayProps>

export type TTabProps = {
  activePage: string
}

export type TTabBarProps = {
  navigation?: NavigationHelpers<ParamListBase, BottomTabNavigationEventMap>
  navigationData: TTabNavigationData
  activePage: TTabProps['activePage']
  className?: string
}
